import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { IconPlayInACircle } from '@redteclab/icons'

import { Dialog, DialogContent, DialogTitle, Link, Notification } from 'base-ui'

import { useExperimentalAddStaticFileHost } from '../../../experiments/new-cdn-experiment/useExperimentalAddStaticFileHost'
import { useOpenableControls } from '../../../generic-hooks'
import poster from '../../images/video-title-screen.jpg'
import { productAccessorIsPrescriptionProduct } from '../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../productPageContext'

import { PRESCRIPTION_PROCESS_VIDEO_SRC } from './prescriptionProcessVideoSrc'

export const ProductPrescriptionNotificationVideo: FC = () => {
  const intl = useIntl()
  const { currentVariant } = useProductPageContext()
  const isPrescriptionProduct =
    productAccessorIsPrescriptionProduct(currentVariant)
  const modalControls = useOpenableControls()
  const { addStaticCdnHostToUrl } = useExperimentalAddStaticFileHost()

  if (!isPrescriptionProduct) {
    return null
  }

  return (
    <Notification icon={<IconPlayInACircle />}>
      <p className="font-medium text-dark-primary-max">
        <FormattedMessage id="productAdditonalInfos.prescription.videobox.headline" />
      </p>
      <FormattedMessage id="productAdditonalInfos.prescription.videobox.content" />
      <div className="flex self-center tablet:self-start">
        <Link
          className="pt-4 font-normal text-dark-primary-max underline"
          onClick={modalControls.handleOpen}
        >
          <FormattedMessage id="productAdditonalInfos.prescription.videobox.links" />
        </Link>
        <Dialog onClose={modalControls.handleClose} open={modalControls.isOpen}>
          <DialogTitle
            onClose={modalControls.handleClose}
            slotProps={{
              closeButton: {
                'aria-label': intl.formatMessage({
                  id: 'general.link.label.close',
                }),
              },
            }}
          >
            <FormattedMessage
              id="productAdditonalInfos.prescription.videobox.modal.headline"
              tagName="h2"
            />
          </DialogTitle>
          <DialogContent className="flex flex-col">
            <video
              autoPlay
              className="h-auto w-full cursor-pointer"
              controls
              poster={poster.src}
              preload="none"
            >
              <source
                src={addStaticCdnHostToUrl(PRESCRIPTION_PROCESS_VIDEO_SRC.MP4)}
                type="video/mp4"
              />
              <source
                src={addStaticCdnHostToUrl(PRESCRIPTION_PROCESS_VIDEO_SRC.WEBM)}
                type="video/webm"
              />
            </video>
          </DialogContent>
        </Dialog>
      </div>
    </Notification>
  )
}
